export const APPLICATION_TITLE = 'NexoTCG';

export const formatDocumentTitle = (pageTitle?: string): string => {
  const normalizedTitle = pageTitle?.trim();

  if (!normalizedTitle || normalizedTitle === APPLICATION_TITLE) {
    return APPLICATION_TITLE;
  }

  return `${normalizedTitle} | ${APPLICATION_TITLE}`;
};
